import { api } from "./client";

const KEY = "poehali_device_id";

export function deviceId() {
  let id = localStorage.getItem(KEY);
  if (!id) {
    id = (crypto.randomUUID ? crypto.randomUUID() : `dev-${Date.now()}-${Math.random()}`).toString();
    localStorage.setItem(KEY, id);
  }
  return id;
}

export async function fetchSettings() {
  const { data } = await api.get("/settings", { params: { device_id: deviceId() } });
  return data;
}

export async function saveRingSound(ringSound) {
  const { data } = await api.patch("/settings", { device_id: deviceId(), ring_sound: ringSound });
  return data;
}
